import { DiagnosisRegistrationStoreData } from '@/pages/demands/contexts/diagnosis-registration-store'

import { ImageCountMapper } from './image-count-mapper'

export interface RawImagesAdapterProps {
  registerData: DiagnosisRegistrationStoreData['registerData']
  selectFilesData: DiagnosisRegistrationStoreData['selectFilesData']
  imageCountMapper: ImageCountMapper
}

export class RawImagesAdapter {
  private registerData
  private selectFilesData
  private imageCountMapper

  constructor(props: RawImagesAdapterProps) {
    this.registerData = props.registerData
    this.selectFilesData = props.selectFilesData
    this.imageCountMapper = props.imageCountMapper
  }

  makeRgbFileReference() {
    if (this.checkImageType()) return

    const input = this.selectFilesData?.rgb?.input

    if (!input) return

    return {
      files: input,
      type: 'raw_images',
      inputType: 'rgb',
      originalNames: input.map((file) => file.name),
      imageCount: this.imageCountMapper.getImageCount(),
    } as const
  }

  makeThermalFileReference() {
    if (this.checkImageType()) return

    const input = this.selectFilesData?.thermal?.input

    if (!input) return

    return {
      files: input,
      type: 'raw_images',
      inputType: 'thermal',
      originalNames: input.map((file) => file.name),
      imageCount: this.imageCountMapper.getImageCount(),
    } as const
  }

  private checkImageType() {
    const { image_type } = this.registerData!

    return image_type !== 'raw_images_geotag' && image_type !== 'raw_images'
  }
}
